function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  padding: 10px;\n  margin-bottom: 20px;\n  color: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  filter: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  margin-right: 5px;\n  margin-top: 5px;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { PureComponent, Fragment } from "react";
import propTypes from "prop-types";
import { withContext } from "../../../wr-context";
import { MediumText, SmallText } from "../../../text";
import { Flipped } from "react-flip-toolkit";
import Card from "../../../card";
import { FiMinusCircle } from "react-icons/fi";
import { GiTwoCoins } from "react-icons/gi";
import Button from "../../../button";
import Badge from "../../../badge";
import { SpacedCol } from "../../../grid";
import Link from "../../../link";
import { generateTransaction } from "../../../../utils/transactions";
import { utils } from "../../../../modules/product";
import i18n, { getLocalizedProperty } from "../../../../utils/i18n";
import { tryCallRenderProp } from "../../../../utils/try-call";
import { getCartId } from "../../../../utils/product/getCartId";
import styled from "styled-components";
var SupplierName = styled.p(_templateObject(), function(param) {
    var theme = param.theme, supplierId = param.supplierId;
    var ref, ref1;
    return supplierId && ((ref = theme.components.supplierBadge) === null || ref === void 0 ? void 0 : ref[supplierId]) ? (ref1 = theme.components.supplierBadge) === null || ref1 === void 0 ? void 0 : ref1[supplierId] : theme.palette.primary;
});
var CoinIcon = styled.span(_templateObject1());
var HeaderLabels = styled.div(_templateObject2());
var HeaderLabel = styled.span(_templateObject3(), function(param) {
    var theme = param.theme, index = param.index;
    return theme.components.productDetails.headerRows.colors[index - 1] ? theme.components.productDetails.headerRows.colors[index - 1].backgroundColor : theme.palette.primary;
}, function(param) {
    var theme = param.theme, index = param.index;
    return theme.components.productDetails.headerRows.colors[index - 1] ? theme.components.productDetails.headerRows.colors[index - 1].filter : "brightness(1.".concat((index / 2).toString().replace(".", ""), ")");
}, function(param) {
    var theme = param.theme, index = param.index;
    return theme.components.productDetails.headerRows.colors[index - 1] ? theme.components.productDetails.headerRows.colors[index - 1].color : "#fff";
}, function(param) {
    var theme = param.theme;
    return theme.components.productDetails.headerRows.borderRadius;
}, function(param) {
    var theme = param.theme;
    return theme.components.productDetails.headerRows.padding;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor && "\n      background: ".concat(backgroundColor, "\n  ");
});
var Product = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(Product, PureComponent);
    var _super = _createSuper(Product);
    function Product() {
        _classCallCheck(this, Product);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            selected: false
        };
        _this.createSelection = function() {
            var price = utils.getPrice(_this.props.product);
            var _product = _this.props.product, id = _product.id, name = _product.name, priceLabel = _product.service_rate_label, description = _product.description;
            var product = {
                id: id,
                name: name,
                priceLabel: priceLabel || utils.getListPrice(_this.props.product),
                price: price,
                description: description
            };
            var transaction = {
                action: "clicked",
                type: "product",
                id: id,
                hname: name
            };
            generateTransaction(transaction);
            if (_this.props.singleSelection) {
                var _props, ref;
                (ref = (_props = _this.props).handleSingleSelection) === null || ref === void 0 ? void 0 : ref.call(_props, _this.props.product.id, _objectSpread({
                    mainProduct: true
                }, product), _this.props.product);
            } else {
                var _props1, ref1;
                _this.setState({
                    selected: !_this.state.selected
                }, (ref1 = (_props1 = _this.props).handleProductSelection) === null || ref1 === void 0 ? void 0 : ref1.call(_props1, product, {
                    removeSelection: _this.state.selected
                }));
            }
        };
        _this.navigateToProductPage = function() {
            var _props = _this.props, context = _props.context, product = _props.product, productTarget = _props.productTarget, fromDecisionTree = _props.fromDecisionTree;
            var isBundle = product.groupType && product.groupType === "bundle";
            if (productTarget === "_blank") {
                window.open("".concat(window.location.origin, "/#").concat(isBundle ? "".concat(context.getRoutePath("bundleDetail"), "/").concat(product.id) : "".concat(context.getRoutePath("productDetail"), "/").concat(product.id)), productTarget);
            } else {
                if (isBundle) {
                    context.history.push(context.getRoutePath("bundleDetail", {
                        bundleId: product.id
                    }));
                } else {
                    context.history.push(context.getRoutePath("productDetail", _objectSpread({
                        productId: product.id
                    }, fromDecisionTree && {
                        fromDecisionTree: "fromDecisionTree"
                    })));
                }
            }
        };
        _this.processHeaderLabels = function() {
            var headerRows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            var labels = [];
            headerRows.forEach(function(row) {
                if (Array.isArray(row.control)) {
                    row.control.forEach(function(cont) {
                        var currentLabel = typeof cont === "string" ? JSON.parse(cont) : cont;
                        labels.push({
                            label: currentLabel.label,
                            rowLabel: row.label
                        });
                    });
                } else if (typeof row.control !== "string") {
                    if (row.control && row.control.label) {
                        labels.push({
                            label: row.control.label,
                            rowLabel: row.label
                        });
                    }
                } else {
                    labels.push({
                        label: row.control,
                        rowLabel: row.label
                    });
                }
            });
            return labels;
        };
        _this.renderHeaderRows = function(headerLabels, headerRowsColors) {
            return /*#__PURE__*/ React.createElement(HeaderLabels, null, headerLabels.map(function(headerLabel, index) {
                var backgroundColor = null;
                if (!headerLabel.label) return null;
                if (headerRowsColors.length) {
                    var currentColor = headerRowsColors.find(function(color) {
                        if (headerLabel.rowLabel.includes(color.label)) return color;
                    });
                    if (currentColor) {
                        backgroundColor = currentColor.color;
                    }
                }
                return /*#__PURE__*/ React.createElement(HeaderLabel, {
                    key: index,
                    index: index + 1,
                    backgroundColor: backgroundColor
                }, headerLabel.label);
            }));
        };
        return _this;
    }
    var _proto = Product.prototype;
    _proto.render = function render() {
        var _this = this;
        var ref;
        var _props = this.props, listMode = _props.listMode, product = _props.product, displayPriceOnList = _props.displayPriceOnList, showPointsLabel = _props.showPointsLabel, displayDurationOnList = _props.displayDurationOnList, hideButtons = _props.hideButtons, context = _props.context, samePageSelection = _props.samePageSelection, singleSelection = _props.singleSelection, showAddedToOrderBadge = _props.showAddedToOrderBadge, showAddedToOrderIcon = _props.showAddedToOrderIcon, showSupplierName = _props.showSupplierName, showHeaderRows = _props.showHeaderRows, categoryClassNameMapping = _props.categoryClassNameMapping, _headerRowsColors = _props.headerRowsColors, headerRowsColors = _headerRowsColors === void 0 ? [] : _headerRowsColors, headerRowsPosition = _props.headerRowsPosition, hidePriceAndDurationIfZero = _props.hidePriceAndDurationIfZero, renderBody = _props.renderBody, renderCustomHeaderTitle = _props.renderCustomHeaderTitle, renderCustomProductFooterButton = _props.renderCustomProductFooterButton, noAnimation = _props.noAnimation;
        var handleClick = samePageSelection ? this.createSelection : this.navigateToProductPage;
        var pointSystem = context.state.pointSystem;
        var selected = singleSelection ? this.props.selected : this.state.selected;
        var isBundle = product.groupType === "bundle";
        var price = isBundle ? ((ref = product.settings) === null || ref === void 0 ? void 0 : ref.displayText) || 0 : utils.getListPrice(product);
        var hours = utils.getListDuration(this.props.product);
        var shouldDisable = context.utils.products.shouldDisable(product.id);
        var headerLabels = this.processHeaderLabels(product.rowsInHeader);
        var categoryClassName = categoryClassNameMapping === null || categoryClassNameMapping === void 0 ? void 0 : categoryClassNameMapping.find(function(categoryClassName) {
            return product.categories.some(function(c) {
                var ref;
                return categoryClassName.category.includes(c === null || c === void 0 ? void 0 : (ref = c.name) === null || ref === void 0 ? void 0 : ref.toLowerCase());
            });
        });
        categoryClassName = categoryClassName ? categoryClassName.className : "";
        var disabledStyles = {
            pointerEvents: "none",
            filter: "grayscale(100%)"
        };
        var ContainerComponent = noAnimation ? Fragment : Flipped;
        var containerComponentProps = noAnimation ? {} : {
            flipId: product.id
        };
        var colSizes = listMode === "list" ? {
            sm: 12,
            md: 12,
            lg: 12
        } : context.constants.product.list.gridColSizes;
        return /*#__PURE__*/ React.createElement(ContainerComponent, _extends({
            "data-testid": "product-list__card-".concat(product.id)
        }, containerComponentProps), /*#__PURE__*/ React.createElement(SpacedCol, _extends({
            xs: 12
        }, colSizes, {
            style: shouldDisable ? disabledStyles : {}
        }), /*#__PURE__*/ React.createElement(Card, {
            categoryClassName: categoryClassName,
            onClick: handleClick,
            selected: selected && showAddedToOrderIcon,
            center: true
        }, function(param) {
            var Header = param.Header, Body = param.Body, Footer = param.Footer;
            var _this1 = _this;
            var ref, ref1;
            /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Header, {
                className: "wr__product-header"
            }, context.state.cart.some(function(v) {
                return v.id === product.id;
            }) && showAddedToOrderBadge && /*#__PURE__*/ React.createElement(Badge, null, /*#__PURE__*/ React.createElement(Button, {
                type: "button",
                onClick: function(e) {
                    e.stopPropagation();
                    context.actions.removeProductFromCart(product.id, product);
                },
                primary: true,
                small: true
            }, /*#__PURE__*/ React.createElement(FiMinusCircle, null), " ", i18n("productDetails.addedToOrder"))), renderCustomHeaderTitle ? renderCustomHeaderTitle({
                props: _this.props,
                headerRows: showHeaderRows && headerRowsPosition === "under-title" && _this.renderHeaderRows(headerLabels, headerRowsColors) || /*#__PURE__*/ React.createElement(React.Fragment, null)
            }) : /*#__PURE__*/ React.createElement(React.Fragment, null, showSupplierName && product.supplierName && /*#__PURE__*/ React.createElement(SupplierName, {
                "data-testid": "product-list-supplier-name",
                className: "product-list-supplier-name",
                supplierId: product.supplierId
            }, product.supplierName), /*#__PURE__*/ React.createElement(MediumText, {
                className: "product-name"
            }, /*#__PURE__*/ React.createElement(Link, {
                "data-testid": "product-list-product-name"
            }, getLocalizedProperty(product, "name")))), tryCallRenderProp(displayPriceOnList, {
                props: _objectSpreadProps(_objectSpread({}, _this.props), {
                    price: price
                }),
                shouldDefaultRender: function() {
                    return true;
                },
                defaultRender: function() {
                    return /*#__PURE__*/ React.createElement(React.Fragment, null, (!hidePriceAndDurationIfZero || !!price || !!hours) && /*#__PURE__*/ React.createElement("div", {
                        className: "product-list-price-duration"
                    }, displayPriceOnList && /*#__PURE__*/ React.createElement(SmallText, {
                        className: "product-list-price"
                    }, /*#__PURE__*/ React.createElement("p", null, pointSystem && /*#__PURE__*/ React.createElement(CoinIcon, null, /*#__PURE__*/ React.createElement(GiTwoCoins, {
                        size: 20
                    })), price, showPointsLabel && " points")), displayDurationOnList && /*#__PURE__*/ React.createElement("div", {
                        className: "product-list-separator"
                    }, "|"), displayDurationOnList && /*#__PURE__*/ React.createElement(SmallText, {
                        className: "product-list-duration"
                    }, /*#__PURE__*/ React.createElement("p", null, hours, " hours"))), !displayPriceOnList && hidePriceAndDurationIfZero && price > 0 && /*#__PURE__*/ React.createElement(SmallText, {
                        className: "product-list-price"
                    }, /*#__PURE__*/ React.createElement("p", null, pointSystem && /*#__PURE__*/ React.createElement(CoinIcon, null, /*#__PURE__*/ React.createElement(GiTwoCoins, {
                        size: 20
                    })), price, showPointsLabel && " points")), showHeaderRows && headerRowsPosition === "under-title" && _this1.renderHeaderRows(headerLabels, headerRowsColors));
                }
            })), /*#__PURE__*/ React.createElement(Body, {
                align: "left",
                "data-testid": "product-list-product-description",
                className: "product-description"
            }, renderBody === null || renderBody === void 0 ? void 0 : renderBody({
                props: _this.props,
                description: getLocalizedProperty(product, "description"),
                headerRows: showHeaderRows && headerRowsPosition === "default" ? _this.renderHeaderRows(headerLabels, headerRowsColors) : undefined
            })), !hideButtons && /*#__PURE__*/ React.createElement(Footer, {
                className: "wr__product-footer"
            }, !renderCustomProductFooterButton ? !context.constants.product.addToCartSkippingDetails ? /*#__PURE__*/ React.createElement(Button, {
                type: "button",
                outline: true
            }, /*#__PURE__*/ React.createElement(Link, null, _this.props.configureButtonLabel)) : /*#__PURE__*/ React.createElement(Button, _extends({
                onClick: function(ev) {
                    ev.stopPropagation();
                    var cartId = getCartId();
                    context.actions.addProductToCart(_objectSpreadProps(_objectSpread({}, product), {
                        cartId: cartId
                    }));
                }
            }, context.constants.product.addToCartButtonProps), ((ref = context.constants.product.addToCartButtonProps) === null || ref === void 0 ? void 0 : ref.children) ? (ref1 = context.constants.product.addToCartButtonProps) === null || ref1 === void 0 ? void 0 : ref1.children(_this.props) : "+") : renderCustomProductFooterButton(_this.props)));
        })));
    };
    return Product;
}(PureComponent);
Product.propTypes = {
    product: propTypes.object.isRequired,
    listMode: propTypes.oneOf([
        "list",
        "grid"
    ]),
    renderBody: propTypes.func,
    fromDecisionTree: propTypes.bool
};
Product.defaultProps = {
    renderBody: function(param) {
        var props = param.props, description = param.description, headerRows = param.headerRows;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, description, headerRows);
    },
    fromDecisionTree: false
};
export default withContext(Product);
